// extracted by mini-css-extract-plugin
export default {"VerifyEmail":"VerifyEmail_VerifyEmail__9P6FM","VerifyEmailInner":"VerifyEmail_VerifyEmailInner__rbOqY"};